import { useTabContext } from "@mui/lab";
import { Box } from "@mui/material";
import { FunctionComponent, PropsWithChildren } from "react";

interface PersistentTabPanelProps {
  value: string;
}

export const PersistentTabPanel: FunctionComponent<PropsWithChildren<PersistentTabPanelProps>> = ({
  children,
  value,
}) => {
  const { value: contextValue } = useTabContext() || {};
  return (
    <Box role="tabpanel" sx={{ display: value === contextValue ? "block" : "none" }} key={value}>
      {children}
    </Box>
  );
};
